<template>
  <div id="home-parent" class="page-container">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image parallax-img"
        style="background-image: url('img/background_0.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Podologiepraxis Boldt.</h1>
          <div class="text-center">
            <h3>Gesunde Füße - mehr Lebensqualität</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-parent">
      <div class="floating-buttons">
        <button class="btn btn-primary btn-icon btn-round btn-lg" @click="openPhone()">
          <span class="mdi mdi-phone-classic"></span>
        </button>
        <button class="btn btn-primary btn-icon btn-round btn-lg" @click="openEmail()">
          <span class="mdi mdi-email-outline"></span>
        </button>
        <button class="btn btn-primary btn-icon btn-round btn-lg" @click="showOpeningHours()">
          <span class="mdi mdi-calendar-clock-outline"></span>
        </button>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Willkommen</h2>
            <h4 class="description">
              Als <strong>staatlich geprüfte Podologin mit Kassenzulassung und sektorale Heilpraktikerin im Bereich Podologie</strong>, biete ich gemeinsam mit meinem Team 
              fachkundige Diagnostik und Therapie für Ihre Fußgesundheit - professionell, individuell und nach höchsten medizinischen Standards.
            </h4>
            <!--
            <h4 class="description">
              Unsere Füße tragen uns durchs Leben - Tag für Tag. Deshalb verdienen sie die bestmögliche medizinische Betreuung. 
              Als <strong>staatlich geprüfte Podologin mit Kassenzulassung</strong> bieten mein Team und ich Ihnen Behandlungen für gesetzlich und privat Versicherte, sowie Selbstzahler an.
            </h4>
            
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Fußgesundheit erhalten und verbessern<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Beschwerden wirksam behandeln<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Ihre Mobilität und Lebensqualität sichern
            </h4>
            -->
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6">
            <div
              class="image-container image-left"
              style="background-image: url('img/landing_img_3.jpg')"
            >
            </div>
          </div>
          <div class="col-md-5">
            <!-- First image on the right side, above the article -->
            <div
              class="image-container image-right"
              style="background-image: url('img/landing_img_2.jpg')"
            ></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Wir behandeln:</h2>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> GKV - Patienten - mit vorlage einer gültigen Heilmittelverordnung (HMV Nr. 13)<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> PKV - Patienten nach GebüH/GebüTR.<br><span>Bitte klären Sie vorab mit Ihrer Versicherung, ob Heilpraktikerleistungen erstattungsfähig sind und ob eine ärztliche Verordnung erforderlich ist.</span><br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Selbstzahler
            </h4>
            <!--
            <h4 class="description">
              Unsere Füße tragen uns durchs Leben - Tag für Tag. Deshalb verdienen sie die bestmögliche medizinische Betreuung. 
              Als <strong>staatlich geprüfte Podologin mit Kassenzulassung</strong> bieten mein Team und ich Ihnen Behandlungen für gesetzlich und privat Versicherte, sowie Selbstzahler an.
            </h4>
            
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Fußgesundheit erhalten und verbessern<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Beschwerden wirksam behandeln<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Ihre Mobilität und Lebensqualität sichern
            </h4>
            -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Vereinbaren Sie jetzt einen Termin - wir freuen uns auf Sie!<br>
              Termine nur nach Vereinbarung<br>
              <n-button type="primary" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 05621 / 96 78 78 6
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@podologie-boldt.de
              </n-button>
            </h4>
          </div>
        </div>
        <div class="separator separator-primary"></div>
      </div>
    </div>
    <div class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: !secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_1_wide.jpg" media="(min-width: 600px)" />
            <img src="img/background_1.jpeg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Unsere Leistungen</h2>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Behandlung von eingewachsenen oder verdickten Nägeln<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Entfernung von Hühneraugen, Schwielen und Druckstellen<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Podologische Komplexbehandlung (z. B. Diabetes, Gefäßerkrankungen)<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Nagelkorrekturspangen<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Orthosen (Druck- und Reibungsschutz)<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Prävention & Beratung zur Fußgesundheit
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Für gesetzlich Versicherte</h2>
            <h4 class="description">
              Mit einer ärztlichen Verordnung können Sie podologische Behandlungen direkt über Ihre gesetzliche Krankenversicherung abrechnen. Typische Indikationen:
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Diabetes mellitus mit Folgeschäden<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Neuropathien<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Durchblutungsstörungen
            </h4>
            <h4 class="description">
              <span class="mdi mdi-lightbulb-on-outline" style="color: yellow"></span> 
              <i style="color: yellow"> Gut zu wissen:</i> Podologische Behandlungen mit Privatrezept können von vielen Privatversicherungen übernommen werden. Sie erhalten eine Rechnung zur Einreichung bei Ihrer Versicherung.
            </h4>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-12 carousel-container">
            <el-carousel :height="carouselHeight" autoplay>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_3.jpg" alt="First slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_4.jpg" alt="Second slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_5.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_6.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_7.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_8.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/heilpraktiker_zertifikat.jpg" alt="Third slide" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Individuelle und einfühlsame Betreuung<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Hohe Hygienestandards<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Zusammenarbeit mit Ärzten bei medizinischer Notwendigkeit
            </h4>
            <h4 class="description">
              Unser hoher Hygienestandard ist durch die Eintragung ins <a class="link" target="_blank" href="https://deutsches-hygiene-register.de/eintraege/natalja-boldt-podologie-fachpraxis-fusspflege-kosmetik-manikuere/">Deutsche Hygieneregister</a> umfassend geprüft und mit sehr gut bewertet.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div id="second-background" class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_2_wide.jpg" media="(min-width: 600px)" />
            <img src="img/background_2.jpeg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Von der Fußpflege zur Podologie</h2>
            <h4 class="description">
              Fußpflege sorgt für gepflegte Füße, aber Podologie geht weiter:
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Medizinischer Fachberuf mit klar definierten Standards<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Behandlung krankhafter Veränderungen am Fuß<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Enge Zusammenarbeit mit Ärzten
            </h4>
            <h4 class="description">
              <strong>Schöne Füße macht die Fußpflege - gesunde Füße die Podologie.</strong>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Kontakt</h2>
        <div class="row">
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <span class="mdi mdi-map-marker-outline"></span> Unsere Adresse:<br>
              Hufelandstraße 14,<br>
              34537 Bad WIldungen
            </h4>
          </div>
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <iframe src="https://maps.google.com/maps?q=Natalja+Boldt+Podologie+Fachpraxis.+Fußpflege,+Kosmetik,+Maniküre+-+Bad+Wildungen&z=16&output=embed"
                allowfullscreen="allowfullscreen" 
                frameborder="0"
                :width="mapWidth"
                :height="mapHeight"
                data-gtm-yt-inspected-11="true" 
                style="border: 0px;">
              </iframe>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 ml-auto mr-auto text-center message-container">
            <fg-input
              class="no-border"
              addon-left-mdi-icon="mdi-account-outline"
              placeholder="Ihr Name"
              v-model="nameValue"
              :class="{'has-danger': !nameFocused && hasNameError, 'has-success': !nameFocused && hasNameSuccess}"
              @focus="nameFocused = true"
              @blur="nameFocused = false; validateName()"
            >
            </fg-input>

            <fg-input
              class="no-border"
              addon-left-mdi-icon="mdi-email-outline"
              placeholder="Ihre E-Mail-Adresse"
              v-model="emailValue"
              :class="{'has-danger': !emailFocused && hasEmailError, 'has-success': !emailFocused && hasEmailSuccess}"
              @focus="emailFocused = true"
              @blur="emailFocused = false; validateEmail()"
            >
            </fg-input>
            <fg-input
              class="no-border"
              addon-left-mdi-icon="mdi-phone-classic"
              placeholder="Ihre Telefonnummer (optional)"
              v-model="phoneValue"
            >
            </fg-input>
          </div>
          <div class="col-lg-6 ml-auto mr-auto text-center message-container">
            <fg-textarea
              class="no-border"
              placeholder="Ihre Nachricht"
              :rows="4"
              v-model="messageValue"
              :class="{'has-danger': !messageFocused && hasMessageError, 'has-success': !messageFocused && hasMessageSuccess}"
              @focus="messageFocused = true"
              @blur="messageFocused = false; validateMessage()"
              ></fg-textarea>
          </div>
          <div class="col-lg-12 ml-auto mr-auto text-center message-container">
            <n-button type="primary" class="phone-btn send-button" :enabled="canSendMessage" round @click="sendMessage()">
              Senden
            </n-button><br>
            
          </div>
          <modal :show.sync="showSuccessAlert"
                class="modal-primary"
                :show-close="false"
                header-classes="justify-content-center"
                type="mini">
            <div slot="header" class="d-flex justify-content-center align-items-center">
              <span class="mdi mdi-email-outline alert-icon"></span>
            </div>
            <p>Ihre Nachricht wurde gesendet!</p>
            <template slot="footer">
              <n-button type="primary close-alert-button" round @click="showSuccessAlert = false">Schließen</n-button>
            </template>
          </modal>
          <modal :show.sync="showErrorAlert"
                class="modal-danger"
                :show-close="false"
                header-classes="justify-content-center"
                type="mini">
            <div slot="header" class="d-flex justify-content-center align-items-center">
              <span class="mdi mdi-email-outline alert-icon"></span>
            </div>
            <p>{{ alertError }}</p>
            <template slot="footer">
              <n-button type="primary close-alert-button" round @click="showErrorAlert = false">Schließen</n-button>
            </template>
          </modal>
        </div>
        <div class="row">
          <div class="col-lg-10 ml-auto mr-auto text-center">
            <!--
            <h4 class="description">
              Rufen Sie uns an:<br>
              
              <n-button type="primary" class="phone-btn" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 05621 / 96 78 78 6
              </n-button><br>
              <span class="opening-time">(Mo-Do 9:00 - 18:00)</span><br>
            </h4>
            <h4 class="description small-margin-bottom">
              Oder schreiben Sie uns eine E-Mail<br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@podologie-boldt.de
              </n-button>
            </h4>
            -->
            <h4 class="description">
              <span class="mdi mdi-heart-outline"></span><strong> Wir freuen uns auf Sie! </strong><span class="mdi mdi-heart-outline"></span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput, Modal } from '@/components';
import { Card, Carousel, CarouselItem } from 'element-ui';
import Parallax from 'vue-parallaxy'
import FormGroupTextArea from '../components/Inputs/formGroupTextArea.vue';

export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [FormGroupTextArea.name]: FormGroupTextArea,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    Modal
  },
  created() {
    //window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    //window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    const options = {
      rootMargin: "0px",
      scrollMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75, 1.00],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(this.intersectionY > entry.boundingClientRect.y && entry.intersectionRatio >= 0.5) {
          this.secondForeground = true;
        } else if(this.previousRatio > entry.intersectionRatio
            && this.intersectionY < entry.boundingClientRect.y 
            && entry.intersectionRatio <= 0.5) {
          this.secondForeground = false;
        }
        this.intersectionY = entry.boundingClientRect.y
        this.previousRatio = entry.intersectionRatio
      });
    }, options);

    const target = document.querySelector("#background-observer");
    observer.observe(target);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize); 
  },
  data() {
    return {
      secondForeground: false,
      intersectionY: 0,
      previousRatio: 0,
      mapWidth: "600px",
      mapHeight: "400px",
      carouselHeight: "300px",
      nameValue: '',
      emailValue: '',
      phoneValue: '',
      messageValue: '',
      nameError: '',
      emailError: '',
      phoneError: '',
      messageError: '',
      nameFocused: false,
      emailFocused: false,
      phoneFocused: false,
      messageFocused: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      alertError: ''
    };
  },
  computed: {
    hasNameError: function() {
      if(this.nameValue.length < 1) {
        return false
      }
      this.validateName()
      return this.nameError.length > 0
    },
    hasEmailError: function() {
      if(this.emailValue.length < 1) {
        return false
      }
      this.validateEmail()
      return this.emailError.length > 0
    },
    hasMessageError: function() {
      if(this.messageValue.length < 1) {
        return false
      }
      this.validateMessage()
      return this.messageError.length > 0
    },
    hasNameSuccess: function() {
      if(this.nameValue.length < 1) {
        return false
      }
      this.validateName()
      return this.nameError.length < 1
    },
    hasEmailSuccess: function() {
      if(this.emailValue.length < 1) {
        return false
      }
      this.validateEmail()
      return this.emailError.length < 1
    },
    hasMessageSuccess: function() {
      if(this.messageValue.length < 1) {
        return false
      }
      this.validateMessage()
      return this.messageError.length < 1
    },
    canSendMessage: function() {
      return this.hasNameSuccess && this.hasEmailSuccess && this.hasMessageSuccess
    }
  },
  methods: {
    onResize() {
      let mapWidth = window.innerWidth - 10
      mapWidth = Math.min(mapWidth, 600)

      const mapHeight = mapWidth / 1.5

      this.mapWidth = mapWidth + 'px'
      this.mapHeight = mapHeight + 'px'

      const carouselContaner = document.getElementsByClassName("carousel-container")[0];
      let carouselWidth = carouselContaner.clientWidth
      carouselWidth = Math.min(carouselWidth, 800)
      this.carouselHeight = (carouselWidth / 2.2) + 'px'
    },
    openPhone: function() {
      window.location = "tel:+4956219678786";
    },
    openWhatsapp: function() {
      window.open("https://wa.me/491756033610", "_blank");
    },
    openEmail: function() {
      window.location = "mailto:kontakt@podologie-boldt.de";
    },
    showOpeningHours: function() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },
    validateName() {
      if(this.nameValue.length < 3) {
        this.nameError = 'Bitte mind. 3 Zeichen eingeben!'
      } else {
        this.nameError = ''
      }
    },
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!re.test(this.emailValue)) {
        this.emailError = 'Bitte eine korrekte E-Mail-Adresse eingeben!'
      } else {
        this.emailError = ''
      }
    },
    validatePhone() {
      if(this.phoneValue.length < 3) {
        this.phoneError = 'Bitte eine Telefon-Nummer eingeben!'
      } else {
        this.phoneError = ''
      }
    },
    validateMessage() {
      if(this.messageValue.length < 10) {
        this.messageError = 'Bitte mind. 10 Zeichen eingeben!'
      } else {
        this.messageError = ''
      }
    },
    async sendMessage() {
      this.alertError = ''
      this.validateName()
      this.validateEmail()
      this.validatePhone()
      this.validateMessage()

      if(!this.canSendMessage) {
        this.alertError = "Bitte alle Felder korrekt ausfüllen:\n"
        if(this.hasNameError) {
          this.alertError += "- Name: " + this.nameError + "\n"
        } else if(!this.hasNameSuccess) {
          this.alertError += "- Name: Bitte ausfüllen!\n"
        }
        if(this.hasEmailError) {
          this.alertError += "- E-Mail: " + this.emailError + "\n"
        } else if(!this.hasEmailSuccess) {
          this.alertError += "- E-Mail: Bitte ausfüllen!\n"
        }
        if(this.hasMessageError) {
          this.alertError += "- Nachricht: " + this.messageError + "\n"
        } else if(!this.hasMessageSuccess) {
          this.alertError += "- Nachricht: Bitte ausfüllen!\n"
        }
        this.showErrorAlert = true
        return
      }

      // try send
      const subject = "Kontaktformular Podologie Boldt"
      const body = "Anfrage:\nName: {0}\nE-Mail: {1}\nTelefonnummer: {2}\nNachricht: {3}"
        .replace("{0}", this.nameValue)
        .replace("{1}", this.emailValue)
        .replace("{2}", this.phoneValue.length > 0 ? this.phoneValue : "keine Angabe")
        .replace("{3}", this.messageValue)
      let params = new URLSearchParams()
      params.append('subject', subject)
      params.append('email', this.emailValue)
      params.append('body', body)

      this.working = true
      try {
        const respone = await fetch("/processRequest.php", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: params
        })
        if(!respone.ok) {
          this.alertError = "Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut oder schreiben Sie uns eine E-Mail an kontakt@podologie-boldt.de"
          this.showErrorAlert = true
          return
        }
        this.showSuccessAlert = true
        this.nameValue = ''
        this.emailValue = ''
        this.phoneValue = ''
        this.messageValue = ''
      } catch(e) {
        this.alertError = "Unerwarteter Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut oder schreiben Sie uns eine E-Mail an kontakt@podologie-boldt.de"
        this.showErrorAlert = true
      } finally {
        this.working = false
      }
    }
  }
};
</script>
<style scoped lang="scss">
.background-img-wrapper {
  background-color: #00000060 !important;

  .title {
    color: white !important;
  }
  .description {
    color: white !important;
    font-weight: normal !important;
  }
  .background-container {
    left: 0;
    bottom: 0;
    position: fixed;
    z-index: -2;
    width: 100vw;
    height: 100vh;

    .background-img {
      * {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
.parallax-img {
  z-index: 0 !important;
}
.foreground {
  z-index: -1 !important;
}
.parallax-test {
  position: relative;
}
.list {
  text-align: left;
  margin-left: 100px;
}
.small-margin-bottom {
  margin-bottom: 5px;
}
.phone-btn {
  margin-bottom: 0 !important;
}
.opening-time {
  font-size: small;
}
.link {
  color: white !important;
  text-decoration: underline;
}
iframe {
  width: 100%;
  height: auto;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 4/3;
}
.video {
  width: auto;
  height: 90vh;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 9/16;
}
.title-logo {
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: 80%;
  height: auto;
}

.carousel-container {
  max-width: 800px !important;
}

.fixed-parent {
  position: fixed;
  
  left: 0;
  bottom: 0;
  
  width: 100vw;
  height: 100vh;

  z-index: 10;
  pointer-events: none;

  .floating-buttons {
    position: absolute;
    right: 20px;

    pointer-events: all;

    display: flex;
    flex-direction: column;

    bottom: 50%;
    transform: translate(0, 50%);

    button {
      background-color: rgb(50, 100, 120) !important;
    }

    span {
      font-size: 24px;
      font-weight: lighter;
    }
  }
}

button {
  background-color: rgb(50, 100, 120) !important;
}

.message-container {
  padding: 0 40px;
}

.alert-icon {
  font-size: x-large;
}

.close-alert-button {
  opacity: 1 !important;
  width: 100% !important;
}
/*
.container {
  animation: fadeIn 0.2ms ease-in-out 0s 1 normal none;
}
*/

@keyframes fadeIn {
  from {
    translate: 150vw 0;
    scale: 200% 1;
    opacity: 0;
  }

  to {
    translate: 0 0;
    scale: 100% 1;
    opacity: 1;
  }
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
